import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center mb-12">联系我们</h2>
        <div className="max-w-lg mx-auto">
          <form className="space-y-6">
            <div>
              <label className="block text-gray-700 mb-2">姓名</label>
              <input
                type="text"
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="请输入您的姓名"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-2">邮箱</label>
              <input
                type="email"
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="请输入您的邮箱"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-2">留言</label>
              <textarea
                className="w-full px-4 py-2 border rounded-lg"
                rows={4}
                placeholder="请输入您的留言"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
            >
              发送消息
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact; 